import { render } from "./Home.vue?vue&type=template&id=fae5bece&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=fae5bece&scoped=true&lang=css"

import exportComponent from "/home/runner/work/channel-xyz/channel-xyz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fae5bece"],['__file',"src/views/Home.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fae5bece"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fae5bece', __exports__)) {
    api.reload('fae5bece', __exports__)
  }
  
  module.hot.accept("./Home.vue?vue&type=template&id=fae5bece&scoped=true", () => {
    api.rerender('fae5bece', render)
  })

}


export default __exports__